import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {FaIcon} from '../../FaIcon';
import {ReportCard} from '../../reports/ReportCard';

export function ReportsPreviewBox({clientId, reports, onDeleteReport, onCancelReport}) {
    const {t, i18n} = useTranslation();

    const displayReports = (reports || []).slice(0, 2);

    return (
        <div className="box reports-preview-box">
            <div className="reports-preview-header">
                <h3 className="reports-preview-title">{t('control_central.reports_title')}</h3>
            </div>

            {displayReports.length > 0 ? (
                <div className="reports-preview-list">
                    {displayReports.map(report => (
                        <ReportCard
                            key={report.report_id}
                            report={report}
                            onDelete={onDeleteReport}
                            onCancel={onCancelReport}
                            showClientName={false}
                            t={t}
                            language={i18n.language}
                        />
                    ))}
                </div>
            ) : (
                <div className="cc-empty-state">
                    <FaIcon iconName="file-lines"/>
                    <p>{t('control_central.reports_empty')}</p>
                    <Link className="btn -alt -small" to={`/agent/chat/?client_id=${clientId}`}>
                        <FaIcon iconName="wand-magic-sparkles"/>
                        {t('control_central.reports_empty_cta')}
                    </Link>
                </div>
            )}

            {(reports || []).length > 0 && (
                <div className="reports-preview-footer">
                    <Link to={`/client/${clientId}/reports`}>
                        {t('control_central.reports_see_all')} &rarr;
                    </Link>
                </div>
            )}
        </div>
    );
}
